var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97634 0.50288C6.12235 0.490761 6.26923 0.511439 6.40621 0.5634C6.54078 0.61444 6.66245 0.694396 6.76268 0.797585L15.5822 9.61712C15.8497 9.88497 16 10.2481 16 10.6266C16 11.0052 15.8495 11.3686 15.582 11.6364L11.136 16.0824C10.8681 16.3498 10.505 16.5001 10.1265 16.5001C9.74789 16.5001 9.38456 16.3496 9.11669 16.0821L0.29739 7.26285C0.19419 7.16262 0.114305 7.04094 0.0632191 6.90638C0.011219 6.76939 -0.00935173 6.62252 0.00276184 6.47651C0.0037899 6.46322 0.00539017 6.44996 0.00744724 6.43677L0.678305 2.08197C0.698647 1.84958 0.800247 1.63132 0.965618 1.46584C1.1311 1.30036 1.34939 1.19882 1.58185 1.17843L5.93661 0.507584C5.9498 0.505552 5.96305 0.503984 5.97634 0.50288ZM4.57217 6.21547C5.20336 6.21547 5.71502 5.7038 5.71502 5.07261C5.71502 4.44144 5.20336 3.92976 4.57217 3.92976C3.94093 3.92976 3.42928 4.44144 3.42928 5.07261C3.42928 5.7038 3.94093 6.21547 4.57217 6.21547Z",
    fill: "#9EA3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkicon);
export default __webpack_public_path__ + "static/media/bookmarkicon.1ebb512f2518c57c6fa05c70cd9c31bb.svg";
export { ForwardRef as ReactComponent };